const faqItems = [
  {
    q: '触手漫画网是什么类型的网站？',
    a: '触手漫画网是一个专注于触手题材漫画的免费在线阅读平台。我们汇集了异世界、奇幻、科幻、都市等多元触手漫画类型，提供高清画质的全集免费阅读服务。无需下载、无需注册，打开浏览器即可畅快阅读。',
  },
  {
    q: '在触手漫画网阅读需要注册账号吗？',
    a: '完全不需要注册！触手漫画网秉持免费开放的理念，所有触手漫画均可直接阅读，无需注册账号，无需登录，无需付费。我们致力于为触手漫画爱好者提供最便捷的在线阅读体验。',
  },
  {
    q: '触手漫画网支持手机阅读吗？',
    a: '当然支持！触手漫画网采用响应式设计，在手机、平板和电脑上都能获得流畅的下拉式阅读体验。无论您使用什么设备，都可以随时随地免费在线看触手漫画全集。',
  },
  {
    q: '触手漫画网的内容更新频率如何？',
    a: '我们保持每日更新，平均每天新增50话以上的触手漫画内容。热门连载漫画与官方同步更新，确保读者第一时间看到最新话。同时，我们也会定期上架新作触手漫画，丰富内容库。',
  },
  {
    q: '如何快速找到我想看的触手漫画？',
    a: '您可以通过首页的话题标签、主题索引和排行榜快速发现热门触手漫画。此外，我们提供了按类型分类的专题合集，覆盖异世界、奇幻、科幻等多种风格，帮助您精准定位感兴趣的触手漫画内容。',
  },
  {
    q: '触手漫画网的画质怎么样？',
    a: '触手漫画网上的所有触手漫画均提供高清画质阅读，图片清晰锐利，文字可辨度高。我们致力于提供最佳的在线阅读画质体验，让每一位触手漫画读者都能沉浸在精美的漫画世界中。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-16 md:py-20 scroll-mt-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-10">
          常见问答
        </h2>
        <div className="space-y-3">
          {faqItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/60"
            >
              <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 mb-2">
                {item.q}
              </h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}